import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import SignInComp from "../features/authentication/SignIn";
import { getUserAndToHome } from "../utils/user";

const SignIn = () => {
  const navigate = useNavigate();

  /**
   * 既にsigninの場合ホームページへ遷移
   */
  useEffect(() => {
    getUserAndToHome(navigate);
  }, [navigate]);

  return <SignInComp />;
};

export default SignIn;
